import React, { useEffect, useState } from "react";
import { maintenance } from "../../types/api";
import { useAsset } from "../../store/store";
import { useS3Upload, S3TempUrl } from "../../utils/s3Client";
import { useDropzone } from "react-dropzone";
import { FileText } from "lucide-react";
interface CreateAssetProps {
  setIsCreating: React.Dispatch<React.SetStateAction<boolean>>;
  isCreating: boolean;
  selectedIds?: string[];
  setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
}
const Maintenance: React.FC<CreateAssetProps> = ({
  setIsCreating,
  isCreating,
  selectedIds,
  setSelectedIds,
}) => {
  const [maintenance, setMaintenance] = useState<maintenance>({
    internalExternal: "",
    Checked: "",
    lastDateOfCheck: "",
    checkCompletedBy: "",
    observation: "",
    actionTaken: "",
    recheckDate: "",
    recheckBy: "",
    files: [],
    image: "",
    equipment: selectedIds || [],
  });
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const {
    // state
    currentMaintenance,
    // function
    createMaintenanceHandler,

    clearData,
  } = useAsset();

  const { getsignedurl } = S3TempUrl();

  const {
    uploadFileToS3,
    progress: uploadProgress,
    uploading,
    error: uploadError,
  } = useS3Upload();

  useEffect(() => {
    const fetchSignedUrl = async () => {
      if (maintenance.image) {
        try {
          const key = maintenance.image.split("amazonaws.com/")[1];
          const url = await getsignedurl(key, "image/jpeg");
          setImageUrl(url);
        } catch (err) {
          console.error("Failed to get signed URL:", err);
          setImageUrl(null);
        }
      } else {
        setImageUrl(null);
      }
    };

    fetchSignedUrl();
  }, [maintenance.image, getsignedurl]);
  const onDrop = async (acceptedFiles: File[]) => {
    // if (mode === "view") return;

    try {
      const uploadedFiles = await Promise.all(
        acceptedFiles.map(async (file) => {
          const url = await uploadFileToS3(file);
          return {
            name: file.name,
            url,
            type: file.type,
            size: file.size,
          };
        })
      );

      setMaintenance({
        ...maintenance,
        files: [
          ...(Array.isArray(maintenance.files) ? maintenance.files : []),
          ...uploadedFiles,
        ],
      });
    } catch (err) {
      // setError("Failed to upload files");
      console.error("File upload error:", err);
    }
  };
  const handleViewFile = async (file: { name: string; type: string }) => {
    try {
      const fileurl = await getsignedurl(file.name, file.type);
      window.open(fileurl, "_blank");
    } catch (err) {
      // setError("Failed to view file");
      console.error("Error viewing file:", err);
    }
  };

  const handleRemoveFile = (index: number) => {
    // if (mode === "view") return;
    const newFiles = Array.isArray(maintenance.files)
      ? [...maintenance.files]
      : [];
    newFiles.splice(index, 1);
    setMaintenance({ ...maintenance, files: newFiles });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
      "application/msword": [".doc", ".docx"],
      "text/plain": [".txt"],
      "image/jpeg": [".jpg"],
      "image/png": [".png"],
    },

    maxSize: 5 * 1024 * 1024,
    // disabled: mode === "view",
  });

  const handelMaintenanceHandler = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setMaintenance((prev) => ({
      ...prev,
      [name]: value,
      equipment: selectedIds || [],
    }));
  };

  return (
    <>
      <div className=" flex w-full h-[80vh] s mt-16 flex-col mb-2 bg-[#f8f8fa] justify-start border-rounded px-3 items-start ">
        {/* header */}
        <div className="w-full flex justify-between items-center  mr-4 mt-2  ">
          <h1 className="font-semibold text-[#1b428a]">Update Maintenance</h1>
        </div>
        <div className="w-full h-full bg-white ">
          <div className="pb-4 overflow-y-scroll mt-5  h-[calc(80vh-200px)] w-full">
            <form className="relative" encType="multipart/form-data">
              <div className="grid grid-cols-4 gap-4">
                {/* Form fields */}
                <div className="flex flex-col">
                  <label className="text-gray-500 font-semibold">
                    Check Internal/External
                  </label>
                  <select
                    className={`border-2 border-[#a5b7cf] p-2 rounded`}
                    name="internalExternal"
                    value={maintenance.internalExternal}
                    onChange={handelMaintenanceHandler}
                    required
                    //   disabled={mode === "view"}
                  >
                    <option value="">Select Category</option>
                    <option value="Internal">Internal</option>
                    <option value="External">External</option>
                  </select>
                </div>
                <div className="flex flex-col">
                  <label className="text-gray-500 font-semibold">
                    What is Checked
                  </label>
                  <textarea
                    className={`border-2 border-[#a5b7cf] p-2 rounded `}
                    name="Checked"
                    value={maintenance.Checked}
                    onChange={handelMaintenanceHandler}
                    required
                    //   disabled={mode === "view"}
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-gray-500 font-semibold">
                    Last Date of Check
                  </label>
                  <input
                    type="date"
                    className={`border-2 border-[#a5b7cf] p-2 rounded`}
                    name="lastDateOfCheck"
                    value={maintenance.lastDateOfCheck}
                    onChange={handelMaintenanceHandler}
                    required
                    //   disabled={mode === "view"}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-gray-500 font-semibold">
                    Check Completed By
                  </label>
                  <input
                    type="text"
                    className={`border-2 border-[#a5b7cf] p-2 rounded `}
                    name="checkCompletedBy"
                    value={maintenance.checkCompletedBy}
                    onChange={handelMaintenanceHandler}
                    required
                    //   disabled={mode === "view"}
                  />
                </div>
                <div className="flex flex-col col-span-1">
                  <label className="text-gray-500 font-semibold">
                    Observation
                  </label>
                  <textarea
                    className={`border-2 border-[#a5b7cf] p-2 rounded`}
                    name="observation"
                    value={maintenance.observation}
                    onChange={handelMaintenanceHandler}
                    //   disabled={mode === "view"}
                  />
                </div>
                <div className="flex flex-col col-span-1">
                  <label className="text-gray-500 font-semibold">
                    Action Taken
                  </label>
                  <textarea
                    className={`border-2 border-[#a5b7cf] p-2 rounded`}
                    value={maintenance.actionTaken}
                    name="actionTaken"
                    onChange={handelMaintenanceHandler}
                    //   disabled={mode === "view"}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-gray-500 font-semibold">
                    Recheck Date
                  </label>
                  <input
                    type="date"
                    className={`border-2 border-[#a5b7cf] p-2 rounded `}
                    value={maintenance.recheckDate}
                    name="recheckDate"
                    onChange={handelMaintenanceHandler}
                    required
                    //   disabled={mode === "view"}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-gray-500 font-semibold">
                    Recheck By
                  </label>
                  <input
                    type="text"
                    className={`border-2 border-[#a5b7cf] p-2 rounded `}
                    value={maintenance.recheckBy}
                    name="recheckBy"
                    onChange={handelMaintenanceHandler}
                    required
                    //   disabled={mode === "view"}
                  />
                </div>
              </div>
              {/* File Upload Section */}
              <div className="flex flex-col mt-6">
                <div className="flex justify-between items-center">
                  <label className="text-gray-500 font-semibold">
                    Upload Files
                  </label>

                  <p className="text-xs text-gray-500 font-semibold">
                    Supported file formats:{" "}
                    <span className="text-orange-500">
                      DOC/DOCX, PDF, TXT, JPG, PNG
                    </span>{" "}
                    (Max: 5MB)
                  </p>
                </div>
                <div
                  className={`border-2 border-[#a5b7cf] p-4 rounded-lg ${"border-dashed"} text-center`}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <p className="text-gray-500 font-semibold">Attached Files</p>
                  <p className="text-gray-500 font-semibold">
                    Drag & Drop Your Files Here or Click
                  </p>

                  {/* Uploaded Files Preview */}
                  <div className="flex gap-4 mt-4 flex-wrap">
                    {Array.isArray(maintenance.files) &&
                      maintenance.files.map((file, index) => (
                        <div
                          key={index}
                          className="flex flex-col items-center bg-gray-100 p-3 rounded-md w-24 relative group"
                        >
                          <FileText size={32} className="text-blue-500" />
                          <p className="text-xs text-gray-600 truncate">
                            {file.name}
                          </p>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveFile(index);
                            }}
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                          >
                            ×
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewFile(file);
                            }}
                            className="absolute -top-2 -left-2 bg-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                            title="View file"
                          >
                            👁️
                          </button>
                        </div>
                      ))}
                    {!Array.isArray(maintenance.files) ||
                    maintenance.files.length === 0 ? (
                      <p className="text-gray-500 text-sm">
                        {/* {mode === "view"
                                        ? "No files attached"
                                        : "No files selected"} */}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>{" "}
              *
            </form>
          </div>
          <div className="w-full h-20 flex justify-end items-center px-5 bg-[#61748e]">
            <button
              className="px-4 py-2  rounded-2xl bg-[#869bb7]"
              onClick={() => {
                setIsCreating(false);
                clearData();
                setSelectedIds([]);
              }}
            >
              <span className="text-white text-lg font-medium">CANCEL</span>
            </button>

            <button
              onClick={() => {
                createMaintenanceHandler(maintenance);
                setIsCreating(false);
                clearData();
                setSelectedIds([]);
              }}
              className="px-4 py-2 ml-3 rounded-2xl bg-[#0fa9a6]"
            >
              <span className="text-white text-lg  font-medium">SUBMIT</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
